import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SiteAboutComponent } from './public/site-about/site-about.component';
import { SiteRootComponent } from './public/site-root/site-root.component';
import { HtmlVideoExampleComponent } from './sandbox/htmlVideo/html-video-example/html-video-example.component';
import { HtmlVideoRecorderExampleComponent } from './sandbox/htmlVideo/html-video-recorder-example/html-video-recorder-example.component';
import { HtmlAudioPlayerExampleComponent } from './sandbox/htmlAudio/html-audio-player-example/html-audio-player-example.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { ThreeDemoComponent } from './sandbox/three/three-demo/three-demo.component';
import { AniFadeExampleComponent } from './sandbox/animation/ani-fade-example/ani-fade-example.component';
import { AniFlipExampleComponent } from './sandbox/animation/ani-flip-example/ani-flip-example.component';
import { UnderConstructionComponent } from './shared/components/under-construction/under-construction.component';
import { SelectivePreloadingStrategy } from './shared/services/selective-preloading-strategy';
import { HtmlScrollWheelComponent } from './sandbox/htmlEvents/html-scroll-wheel/html-scroll-wheel.component';
import { PieChartComponent } from './sandbox/d3/examples/pie-chart/pie-chart.component';
import { PieV4Component } from './sandbox/d3/examples/pie-v4/pie-v4.component';
import { PieV4ObjectsComponent } from './sandbox/d3/examples/pie-v4-objects/pie-v4-objects.component';
import { DonutV4Component } from './sandbox/d3/examples/donut-v4/donut-v4.component';
import { StarburstV4Component } from './sandbox/d3/examples/starburst-v4/starburst-v4.component';
import { ScatterPlotV4Component } from './sandbox/d3/examples/scatter-plot-v4/scatter-plot-v4.component';
import { BarChartExampleComponent } from './sandbox/d3/examples/bar-chart-example/bar-chart-example.component';
import { LinkAnalysisExampleComponent } from './sandbox/d3/examples/link-analysis-example/link-analysis-example.component';
import { DataTestComponent } from './sandbox/data/data-test/data-test.component';
import { DynamicSVGComponent } from './sandbox/svg/dynamic-svg/dynamic-svg.component';
import { ParticleTestComponent } from './sandbox/tsParticles/particle-test/particle-test.component';


const routes: Routes = [
  { path: 'home', component: SiteRootComponent }  
  , { path: 'about', component: SiteAboutComponent }  
  , { path: 'contactus', component: UnderConstructionComponent  }
  , { path: 'underconstruction', component: UnderConstructionComponent}
  // sandbox
  , { path: 'sandbox/htmlvideo/player', component: HtmlVideoExampleComponent  }
  , { path: 'sandbox/htmlvideo/recorder', component: HtmlVideoRecorderExampleComponent  }
  , { path: 'sandbox/htmlaudio/player', component: HtmlAudioPlayerExampleComponent }
  , { path: 'sandbox/htmlScrollWheel', component: HtmlScrollWheelComponent  }
  , { path: 'sandbox/three/demo', component: ThreeDemoComponent  }
  , { path: 'sandbox/aniFade', component: AniFadeExampleComponent}
  , { path: 'sandbox/aniFlip', component: AniFlipExampleComponent}

  
  , { path: 'sandbox/d3/pie', component: PieChartComponent  }
  , { path: 'sandbox/d3/piev4', component: PieV4Component }
  , { path: 'sandbox/d3/piev4obj', component: PieV4ObjectsComponent }
  , { path: 'sandbox/d3/link', component: LinkAnalysisExampleComponent}
  , { path: 'sandbox/d3/donutv4', component: DonutV4Component }
  , { path: 'sandbox/d3/sunburstv4', component: StarburstV4Component }
  , { path: 'sandbox/d3/scatterv4', component: ScatterPlotV4Component }
  , { path: 'sandbox/d3/bar', component: BarChartExampleComponent  }
  , { path: 'sandbox/d3/link', component: LinkAnalysisExampleComponent  }
  , { path: 'sandbox/rxjs/apitest', component: DataTestComponent}
  , { path: 'sandbox/dynamicsvg', component: DynamicSVGComponent}
  , { path: 'sandbox/tsparticles', component: ParticleTestComponent}
  
  , { path: 'book/Success', redirectTo: '/underconstruction', pathMatch: 'full'}
  , { path: 'book/Leadership', redirectTo: '/underconstruction', pathMatch: 'full'}
  , { path: 'book/Teams', redirectTo: '/underconstruction', pathMatch: 'full'}
  , { path: 'book/Mentoring', redirectTo: '/underconstruction', pathMatch: 'full'}
  , { path: 'book/Strategy', redirectTo: '/underconstruction', pathMatch: 'full'}
  , { path: 'book/Luck', redirectTo: '/underconstruction', pathMatch: 'full'}
  , { path: 'book/Podcasting', redirectTo: '/underconstruction', pathMatch: 'full'}
  , { path: 'book/Blogging', redirectTo: '/underconstruction', pathMatch: 'full'}


/*
  { path: 'dosomething', component: DoSomethingComponent }
  
  , { path: 'dosomethingelse', component: DoSomethingElseComponent }
  , { path: 'kb', component: KanbanDashboardComponent }
  
  
  , 
  
  
  , { path: 'blog', loadChildren: 'app/blog/blog.module#BlogModule', data: { preload: true} }
  , { path: 'account', loadChildren: 'app/account/account.module#AccountModule', data: { preload: true} }
  , { path: 'fantasy', loadChildren: 'app/fantasy/fantasy.module#FantasyModule', data: { preload: false} }  
  , { path: 'tools', loadChildren: 'app/tools/tools.module#ToolsModule', data: { preload: false} }
  
  , 
  */
 , { path: 'scott/bio', redirectTo: '/profiles/scott/bio', pathMatch: 'full'}
 , { path: 'scott', redirectTo: '/profiles/scott/bio', pathMatch: 'full'}
 , { path: 'profiles', loadChildren: () => import('./profiles/profiles.module').then(m => m.ProfilesModule), data: { preload: false} }
 , { path: 'sports', loadChildren: () => import('./sports/sports.module').then(m => m.SportsModule), data: { preload: false} }
 , { path: 'soccer', redirectTo: '/sports', pathMatch: 'full'}
 , { path: '', redirectTo: '/home', pathMatch: 'full'}
 , { path: '**', component: PageNotFoundComponent, data: {title: 'Passed-In Page Title', someOtherStuff: 'blah'}}
 

];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    { preloadingStrategy: SelectivePreloadingStrategy, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [
    SelectivePreloadingStrategy
  ]
})
export class AppRoutingModule { }
